import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import logo from "../../images/logo-nero-sportid.svg";
import MyApiClient from '../../api-client/MyApiClient';

const ConvertPhone = () => {
    const { phoneNumber, userId, clubId } = useParams();
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        // Verifica che tutti i parametri necessari siano presenti
        if (!phoneNumber || !userId || !clubId) {
            console.error('Parametri mancanti nell\'URL');
        }
    }, [phoneNumber, userId, clubId]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const newErrors = {};
        
        if (!email) {
            newErrors.email = 'L\'indirizzo email è obbligatorio';
        } else if (!validateEmail(email)) {
            newErrors.email = 'Inserisci un indirizzo email valido';
        }
        
        setErrors(newErrors);
        
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            
            try {
                // Qui andrà la logica per inviare i dati al server
                console.log('Dati da inviare:', {
                    phoneNumber,
                    userId,
                    clubId,
                    email
                });
                
                const apiClient = new MyApiClient();
                const response = await apiClient.convertPlayers(userId, clubId, phoneNumber, email);
                console.log(response);
                if(response.error && response.error.detail){
                    setErrors({ general: response.error.detail });
                } else {
                    setSuccess(true);
                }
                
            } catch (error) {
                console.error('Errore durante l\'invio:', error);
                setErrors({ general: 'Si è verificato un errore. Riprova più tardi.' });
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="vh-100 d-flex align-items-center" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={5}>
                        <Card className="shadow-sm border-0">
                            <Card.Body className="p-5">
                                <div className="text-center mb-4">
                                    <img src={logo} alt="SportID" style={{ height: '60px' }} />
                                </div>
                                
                                <h4 className="text-center mb-4 text-dark">
                                    Fornisci il tuo indirizzo e-mail
                                </h4>
                                
                                <Alert variant="warning" className="mb-4" style={{backgroundColor: '#fff3cd', borderColor: '#ffeaa7', color: '#856404'}}>
                                    <strong>Inserisci il tuo indirizzo email per ricevere l'invito della struttura e poter continuare con la registrazione.</strong>
                                </Alert>
                                
                                {phoneNumber && (
                                    <div className="mb-3">
                                        <small className="text-muted">
                                            Numero di telefono: <strong>{phoneNumber}</strong>
                                        </small>
                                    </div>
                                )}
                                
                                {success ? (
                                    <Alert variant="success">
                                        <h5>Salvataggio completato!</h5>
                                        <p>Controlla la tua email per le istruzioni per continuare la registrazione.</p>
                                    </Alert>
                                ) : (
                                    <Form onSubmit={handleSubmit}>
                                        {errors.general && (
                                            <Alert variant="danger">
                                                {errors.general}
                                            </Alert>
                                        )}
                                        
                                        <Form.Group className="mb-3">
                                            <Form.Label>Indirizzo Email *</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Inserisci il tuo indirizzo email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                isInvalid={!!errors.email}
                                                disabled={loading}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        
                                        <Button 
                                            variant="primary" 
                                            type="submit" 
                                            className="w-100"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Elaborazione...
                                                </>
                                            ) : (
                                                'Continua'
                                            )}
                                        </Button>
                                    </Form>
                                )}
                                
                                <div className="text-center mt-4">
                                    <small className="text-muted">
                                        Hai bisogno di aiuto? Contatta il supporto
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ConvertPhone;